import { IApplicationState, TBoardId } from '../../../../types/types';
import { getBoard } from '../../selectors/getBoardById';

export const getBoardMetaWarnings = (state: IApplicationState, boardId: TBoardId): string[] => {
    const board = getBoard(state, boardId);
    return board.meta && board.meta.warnings;
};
